<template>
    <v-card v-show="!$store.getters.progress" :elevation="1" class="round-card background-2" width="100%" style="border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;">
        <v-progress-linear indeterminate v-show="loading" value="15"></v-progress-linear>
        <v-col ref="googleMap" id="map" class="round-card" style="height: 75vh; border-top-left-radius: 0px !important; border-top-right-radius: 0px !important;"></v-col>
        <v-card id="legend" class="pa-4 pl-3 round-card background-1" style="border-top-left-radius: 0px !important; border-bottom-left-radius: 0px !important;"></v-card>
        <div id="map_canvas"></div>

    </v-card>
</template>

<script>
    import Vue from 'vue'
    import MapInfo from '@/components/common/MapInfo'
    import GoogleMapsApiLoader from 'google-maps-api-loader'
    import HTMLMarker from '@/components/utilities/HTMLMarker.js'
    import { MarkerClusterer } from '@googlemaps/markerclusterer'

    export default {
        name: 'maps',
        components: {
        },

        props: {
            modelDef: String,
            search: String,
            advancedFilters: Object
        },

        data() {
            return {
                apiKey: 'AIzaSyDLyyyf7mgeBAokzar4vbHvmN3eyKthe0w',
                locations: [],
                markers: [],
                markerClusterer: [],
                infoWindows: null,
                places: [],
                currentPlace: null,
                google: null,
                map: null,
                service: null,
                icons: null,
                mapConfig: {
                    center: { lat: 41.9102411, lng: 12.3955718 },
                    zoom: 10,
                    mapTypeId: 'roadmap',
                },
                debounceBounds: null,
                bounds: null,
                logoBase64: '',
                loading: false
            }
        },

        async mounted() {
            try {
                this.geolocate()

                // Carica prima Google Maps API
                const googleMapApi = await GoogleMapsApiLoader({
                    apiKey: this.apiKey,
                    libraries: ['places']
                })
                this.google = googleMapApi

                const mapContainer = this.$refs.googleMap
                this.map = new this.google.maps.Map(mapContainer, this.mapConfig)
                this.google.maps.event.trigger(this.map, 'resize')
                this.service = new this.google.maps.places.PlacesService(this.map)

                // Inizializza le icone
                this.initializeIcons()

                // Inizializza la legenda
                this.initializeLegend()

                // Inizializza gli event listener
                this.initializeMapEventListeners()

                // Ora inizializza HTMLMarker dopo che Google Maps è caricato
                await this.initializeCustomMarker()

                // Trigger iniziale per caricare i dati se bounds sono disponibili
                if (this.bounds) {
                    this.getDataFromApi()
                }

            } catch (error) {
                console.error('Errore durante il caricamento della mappa:', error)
                this.loading = false
            }
        },

        watch: {
            search: {
                handler(newValue, oldValue) {
                    if(this.debounceBounds) clearTimeout(this.debounceBounds)
                    this.debounceBounds = setTimeout(() => {
                        if(newValue != oldValue) {
                            this.removeMarkers()
                        }
                    }, 500)
                }
            },
        },

        methods: {

            async initializeCustomMarker() {
                const address_lat = this.$store.getters.getSetting('address_lat')
                const address_lng = this.$store.getters.getSetting('address_lng')

                if(address_lat && address_lng && this.google && this.google.maps) {
                    this.mapConfig.center = {lat: address_lat, lng: address_lng}

                    try {
                        const response = await this.axios.get('get-logo')
                        this.logoBase64 = response.data.logo

                        // Verifica che google.maps sia disponibile prima di procedere
                        if (typeof this.google.maps.OverlayView !== 'undefined') {
                            HTMLMarker.prototype = new this.google.maps.OverlayView()
                            HTMLMarker.prototype.onRemove = function(){}

                            const logo = this.logoBase64
                            HTMLMarker.prototype.onAdd = function(){
                                var div = document.createElement('div')
                                div.classList.add('arrow_box', 'custom-avatar')
                                div.style.cssText = 'background-image: url("' + logo + '"); border-radius: 50% !important; background-size: contain !important; background-position: center !important'

                                var panes = this.getPanes()
                                panes.overlayImage.appendChild(div)
                            }

                            HTMLMarker.prototype.draw = function(){
                                var overlayProjection = this.getProjection()
                                var position = overlayProjection.fromLatLngToDivPixel(this.pos)
                                var panes = this.getPanes()
                                panes.overlayImage.style.left = position.x + 'px'
                                panes.overlayImage.style.top = position.y - 30 + 'px'
                            }

                            var htmlMarker = new HTMLMarker(address_lat, address_lng)
                            htmlMarker.setMap(this.map)
                        }
                    } catch (error) {
                        console.error('Errore durante il caricamento del logo:', error)
                    }
                }
            },

            initializeIcons() {
                const iconBase = '/img/icons/pin_'
                this.icons = {
                    lead: {
                        name: 'Lead',
                        icon: iconBase + 'lead.svg',
                    },
                    prospect: {
                        name: 'Prospect',
                        icon: iconBase + 'prospect.svg',
                    },
                    customer: {
                        name: 'Cliente',
                        icon: iconBase + 'customer.svg',
                    },
                }
            },

            initializeLegend() {
                if (!this.map || !this.icons) return

                const legend = document.getElementById('legend')
                if (!legend) return

                // Pulisce la legenda esistente
                legend.innerHTML = ''

                for (const key in this.icons) {
                    const type = this.icons[key]
                    const name = type.name
                    const icon = type.icon
                    const div = document.createElement('div')

                    div.innerHTML = '<div style="display: flex; padding-bottom: 4px"><img style="width: 24px" src="' + icon + '"><div style="margin: auto;margin-left: 4px; font-size: 12px; font-weight: normal">' + name + '</div></div>';
                    legend.appendChild(div)
                }

                this.map.controls[this.google.maps.ControlPosition.LEFT_CENTER].push(legend)
            },

            initializeMapEventListeners() {
                if (!this.map) return

                // load more result when move in maps
                this.map.addListener('bounds_changed', () => {
                    if(this.debounceBounds) clearTimeout(this.debounceBounds)

                    this.debounceBounds = setTimeout(() => {
                        this.bounds = this.map.getBounds().toJSON()
                        this.getDataFromApi()
                    }, 500)
                })

                // event close info window
                this.$eventBusUtility.$on('closeInfoWindow', () => {
                    if (this.infoWindows) {
                        this.infoWindows.close()
                        this.$set(this, 'infoWindows', null)
                    }
                })

                this.$eventBusUtility.$on('filters_'+this.modelDef, () => {
                    localStorage.setItem('crud_advancedFilters_'+this.modelDef, JSON.stringify(this.advancedFilters))
                    this.removeMarkers()
                })
            },

            removeMarkers(callApi = true) {
                if (Array.isArray(this.markerClusterer)) {
                    this.markerClusterer.forEach(c => c && c.clearMarkers && c.clearMarkers())
                }
                this.markerClusterer = []
                this.$set(this, 'locations', null)
                if (this.markers && this.markers.length > 0) {
                    _.forEach(this.markers, (marker, key) => {
                        if (marker && marker.setMap) {
                            this.markers[key].setMap(null)
                        }
                    })
                }
                this.$set(this, 'markers', [])
                if(callApi) {
                    this.getDataFromApi(true)
                }
            },

            getDataFromApi() {
                if (!this.map || !this.google || !this.google.maps) {
                    console.warn('Mappa non ancora inizializzata, rimando chiamata API')
                    return
                }

                this.loading = true
                let dataObject = {
                    advancedFilters: this.advancedFilters,
                    filter: this.search,
                    location: true,
                    bounds: this.bounds
                }

                this.axios.post(this.modelDef + '-filters', dataObject).then(response => {
                    try {
                        // get body data
                        this.locations = response.data.data.data

                        // Cleanup markers e clusterer precedenti prima di crearne di nuovi
                        if (Array.isArray(this.markerClusterer)) {
                            this.markerClusterer.forEach(c => c && c.clearMarkers && c.clearMarkers())
                        }
                        this.markerClusterer = []
                        if (this.markers && this.markers.length > 0) {
                            this.markers.forEach(m => { if (m && m.setMap) m.setMap(null) })
                        }
                        this.markers = []

                        // create markers
                        this.markers = this.locations.map((marker) => {
                            if (!marker.legal_address_lat || !marker.legal_address_lng) {
                                console.warn('Marker senza coordinate valide:', marker)
                                return null
                            }

                            let m = new this.google.maps.Marker({
                                position: {'lat': parseFloat(marker.legal_address_lat), 'lng': parseFloat(marker.legal_address_lng)},
                                map: this.map,
                                icon: this.icons[marker.company_status] ? this.icons[marker.company_status].icon : this.icons['customer'].icon
                            })
                            m.set('companyStatus', marker.company_status || 'customer')

                            m.addListener('click', () => {
                                if(this.infoWindows) {
                                    this.infoWindows.close()
                                    this.$set(this, 'infoWindows', null)
                                }

                                if (this.service && marker.place_id) {
                                    this.service.getDetails({placeId: marker.place_id, fields: ['photo', 'name', 'url', 'formatted_address'] }, (place, status) => {
                                        if (status == this.google.maps.places.PlacesServiceStatus.OK) {
                                            marker.url = place.url
                                            marker.full_address = place.formatted_address
                                            var photos = place.photos
                                            if (photos) {
                                                marker.photo = photos[0].getUrl()
                                            }
                                        }

                                        this.createInfoWindow(marker, m)
                                    })
                                } else {
                                    this.createInfoWindow(marker, m)
                                }
                            })

                            return m
                        }).filter(marker => marker !== null) // Rimuove i marker null

                        const google = this.google
                        const statusColors = {
                            lead:     '#FF5252',
                            prospect: '#00B0FF',
                            customer: '#76FF03',
                        }
                        const markersByStatus = { lead: [], prospect: [], customer: [] }
                        this.markers.forEach(mk => {
                            const s = mk.get('companyStatus')
                            if (markersByStatus[s]) markersByStatus[s].push(mk)
                            else markersByStatus.customer.push(mk)
                        })
                        this.markerClusterer = Object.entries(markersByStatus)
                            .filter(([, list]) => list.length > 0)
                            .map(([status, list]) => {
                                const color = statusColors[status]
                                return new MarkerClusterer({
                                    markers: list,
                                    map: this.map,
                                    renderer: {
                                        render: ({ count, position }) => {
                                            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50"><circle cx="25" cy="25" r="22" fill="${color}" stroke="white" stroke-width="3" opacity="0.92"/></svg>`
                                            return new google.maps.Marker({
                                                position,
                                                icon: {
                                                    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
                                                    scaledSize: new google.maps.Size(50, 50),
                                                },
                                                label: { text: String(count), color: 'white', fontWeight: 'bold', fontSize: '13px' },
                                                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                                            })
                                        }
                                    }
                                })
                            })
                        this.loading = false
                        this.$store.commit('endProgress')
                    } catch (error) {
                        console.error('Errore durante la creazione dei marker:', error)
                        this.loading = false
                    }
                }, response => {
                    console.error('Errore chiamata API:', response)
                    this.loading = false
                })
           },

           createInfoWindow(marker, mapMarker) {
                try {
                    var InfoWindow = Vue.extend(MapInfo)
                    var instance = new InfoWindow({
                        propsData: {
                            content: marker,
                            apiKey: this.apiKey,
                            router: this.$router
                        }
                    })

                    instance.$mount()
                    this.infoWindows = new this.google.maps.InfoWindow({
                        content: instance.$el,
                    })
                    this.infoWindows.open(this.map, mapMarker)
                } catch (error) {
                    console.error('Errore durante la creazione della InfoWindow:', error)
                }
           },

            setPlace(place) {
                this.currentPlace = place
            },

            async geolocate() {
                try {
                    // Usa il servizio Capacitor per la geolocalizzazione
                    const result = await this.$capacitor.getCurrentPosition({
                        enableHighAccuracy: true,
                        timeout: 10000
                    })

                    if (result.success && result.coords) {
                        this.$set(this.mapConfig.center, 'lat', result.coords.latitude)
                        this.$set(this.mapConfig.center, 'lng', result.coords.longitude)
                    }
                } catch (error) {
                    console.warn('Errore geolocalizzazione:', error)
                    // Fallback: prova con l'API nativa del browser
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                this.$set(this.mapConfig.center, 'lat', position.coords.latitude)
                                this.$set(this.mapConfig.center, 'lng', position.coords.longitude)
                            },
                            (err) => {
                                console.warn('Fallback geolocalizzazione fallito:', err)
                            }
                        )
                    }
                }
            },

            addMarker() {
                if (this.currentPlace) {
                    const marker = {
                        lat: this.currentPlace.geometry.location.lat(),
                        lng: this.currentPlace.geometry.location.lng()
                    }
                    this.markers.push({ position: marker })
                    this.places.push(this.currentPlace)
                    this.center = marker
                    this.currentPlace = null
                }
            },

        },
    }
</script>

<style>
    button.gm-ui-hover-effect {
        display: none !important;
    }
    .gm-style-iw.gm-style-iw-c {
        padding: 0px !important;
        border-radius: 4px !important;
        min-width: 310px !important;
        font-weight: normal !important;
    }

    .gm-style-iw-d {
        overflow: auto !important
    }
    div >>> .v-list__tile {
        height: 42px;
        -webkit-user-select: auto;
        user-select: auto;
    }
    .gm-style-mtc > div {
        height: 36px !important;
        font-size: 14px !important;
    }
    .gm-style-mtc div {
        font-size: 14px !important;
        box-sizing: border-box;
    }
    .gm-control-active.gm-fullscreen-control {
        height: 34px !important;
        width: 34px !important;
    }
    .gm-control-active.gm-fullscreen-control > img {
        height: 14px !important;
        width: 14px !important;
    }
    button.gm-control-active {
        height: 34px !important;
        width: 34px !important;
    }
    .gm-control-active > img {
        height: 14px !important;
        width: 14px !important;
    }
    .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom > .gmnoprint > div {
        width: 34px !important;
        height: 69px !important;
    }
    .gm-svpc {
        height: 34px !important;
        width: 34px !important;
        top: 10px !important;
    }
    .gm-svpc > div > img {
        height: 22px !important;
        width: 22px !important;
    }

    /*******************HTML MARKER */

    div.arrow_box{
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin: -50px 0px;
        border: solid 3px #ffc107 !important;
        cursor: pointer;
        overflow: hidden;
    }
    div.arrow_box img{
        min-width:50px;
        width:auto;
        max-height:50px;
        height:auto;
    }
    .arrow_box:after {
        top: 5px;
        left: 9px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-top-color: #ffc107 !important;
        border-width: 16px;
        margin-left: 0px;
    }
</style>